<template>
  <v-app :class="$vuetify.breakpoint.smAndDown ? 'page-mobile': 'page-desktop'">
    <v-toolbar app>
      <v-btn
              id="logo"
              flat
              class="btn-logo"
              active-class="none"
              to="/">
        <v-img :src="require('@/assets/EP-logo.png')"/>
      </v-btn>
      <v-spacer></v-spacer>
        <v-icon class="mr-2">fas fa-phone-square</v-icon>
        <span id="phone-number" class="title mr-2">03501 / 58 26 442</span>
        <span class="subheading mr-2 hidden-sm-and-down">Rufen Sie uns an!</span>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
      <v-footer
              height="auto"
              color="primary"
      >
          <v-layout
                  justify-center
                  row
                  wrap
          >
              <v-btn
                      v-for="link in links"
                      :key="link.to"
                      color="white"
                      :to="link.to"
                      flat
                      round
              >
                  {{ link.label }}
              </v-btn>
              <v-flex
                      primary
                      lighten-2
                      py-3
                      text-xs-center
                      white--text
                      xs12
              >
                  &copy;2019 — <strong><a href="http://www.hexnut.de">HEXNUT</a></strong>
              </v-flex>
          </v-layout>
      </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      links: [
        {label: 'Impressum', to:'impressum'},
        {label: 'Datenschutz', to:'datenschutz'},
        {label: 'AGB', to:'agb'},
        {label: 'Widerruf', to:'widerruf'},
      ]
    }
  },
  mounted() {
    // this.$store.dispatch('resetState')
  }
}
</script>

<style lang="scss">
    .page-mobile {
        .v-toolbar__content {
            padding: 0 !important;
        }
        .title {
            font-size: 17px !important;
        }
        h1 {
            font-size: 20px;
        }
        .headline {
            font-size: 14px !important;
            line-height: normal !important;
        }
        .bottom-half {
            .price {
                padding-right: 15px;
            }
        }

    }

    #phone-number {
        color: #EE2E2A;
    }
    #logo {
        margin: 0;
        width: 200px;
        height: 100%;
    }
</style>